export default () => {
  // prevent multiple clicks on submit buttons when form contains class "_js-single-submit"
  /*    document.addEventListener('submit', (e) => {
        const form = e.target;
        if (!form.classList.contains('_js-single-submit')) return;

        const submitButton = form.querySelector(
            'button[type="submit"], input[type="submit"]'
        );

        if (!submitButton) {
            return;
        }

        if (submitButton.dataset.submitted === '1') {
            e.preventDefault();
            return;
        }
        showLoadingScreen()
        console.log('force _jssinglesubmit');
        submitButton.dataset.submitted = '1';
        submitButton.disabled = true;
    }, true);*/

  document.addEventListener(
    'submit',
    (e) => {
      const form = e.target;
      if (!form.classList.contains('_js-single-submit')) return;

      if (form.dataset.submitted === '1') {
        e.preventDefault();
        return;
      }

      form.dataset.submitted = '1';
      showLoadingScreen();
      console.log('force _jssinglesubmit');

      // optional: UI sperren
      const btn = form.querySelector('button[type="submit"], input[type="submit"]');
      if (btn) {
        btn.style.pointerEvents = 'none';
        btn.classList.add('is-disabled');
      }
    },
    true,
  );
};
